import React, { useEffect, useState } from 'react'

import { Container, Typography,} from '@material-ui/core'

import { Switch, useHistory } from 'react-router'
import RoutePrivate from './RoutePrivate'

import AppBar from '../components/AppBar';
import AppDrawer from '../components/AppDrawer';

import MainScreen from '../screens/MainScreen'
import ProductsScreen from '../screens/Products/ProductsScreen'
import { useSelector } from 'react-redux';
import { ProductDetails } from '../screens/Products/ProductDetails';

const MainRoutes = () => {

    const [open, setopen] = useState(false)

    const handleOpen = () => {
        setopen(true)
    }

    const handleClose = () => {
        setopen(false)
    }

    const state = useSelector(state => state.user.user)
    const history = useHistory()

    useEffect(() => {
        if(state === null){
            history.push("/")
        }
        return () => {
        }
    }, [state])

    return (
        <Container disableGutters maxWidth={false} >
            <AppBar onMenuToggle={handleOpen} />
            <AppDrawer open={open} onClose={handleClose} >
                <Switch >
                    <RoutePrivate exact path="/" component={MainScreen}/>
                    <RoutePrivate exact path="/products" component={ProductsScreen}/>
                    <RoutePrivate exact path="/products/:id" component={ProductDetails}/>
                </Switch>
            </AppDrawer>
        </Container>
    )
}

export default MainRoutes
